/* Give images in Shopify page/article HTML a crop frame as well. */
(() => {
  function frameImage(img) {
    if (img.closest('.image-content-frame') || !img.isConnected) return;
    const width = img.clientWidth;
    const height = img.clientHeight;
    if (!width || !height) return;
    const frame = document.createElement('span');
    frame.className = 'image-position image-content-frame';
    frame.style.width = `${width}px`;
    frame.style.aspectRatio = `${width} / ${height}`;
    const computed = getComputedStyle(img);
    frame.style.margin = computed.margin;
    img.before(frame);
    frame.append(img);
  }
  function initialize(root) {
    root.querySelectorAll('[data-image-content] img').forEach(img => {
      if (img.complete) frameImage(img);
      else img.addEventListener('load', () => frameImage(img), { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
